<template>
  <div>
    <!-- /.box-header -->
    <section class="content-header" style="height: 50px;">
      <h1 style="float: left; padding-right: 10px;">{{title}}</h1>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <div slot="content">
          <div class="col-lg-4 col-md-4 col-sm-12">
            <va-box title="Dealer Information" :isBorder="true" theme="box-warning" widgetType="question">
              <div slot="content">
                <div class="col-sm-12" v-for="item in dealerInfo" style="padding-bottom: 10px;">
                  <span class="description-text">{{item.title}}</span>
                  <div class="description-block" style="background-color: #eee; padding: 5px; margin: 0px; height: 30px;">
                    <b class="text-right pull-right" v-html="item.value"></b>
                  </div>
                </div>
              </div>
            </va-box>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <va-box title="Dealer Progress" :isBorder="true" theme="box-warning" widgetType="question">
              <div slot="content">
                <div class="col-sm-12" v-for="item in dealerProgress" style="padding-bottom: 10px;">
                  <span class="description-text">{{item.title}}</span>
                  <div class="description-block" style="background-color: #eee; padding: 5px; margin: 0px; height: 30px;">
                    <b class="text-right pull-right" v-html="item.value"></b>
                  </div>
                </div>
              </div>
            </va-box>
          </div>
          <!--<div class="col-lg-3 col-md-3 col-sm-12">
    <va-box title="Printer Counters" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerCounters">
      <div slot="content">
        <div class="col-sm-12" v-for="item in printerCounters" style="padding-bottom: 10px;">
          <span class="description-text">{{item.title}}</span>
          <div class="description-block" style="background-color: #eee; padding: 5px; margin: 0px; height: 30px;">
            <b class="text-right pull-right">{{item.value}}</b>
          </div>
        </div>
      </div>
    </va-box>
  </div>-->
          <div class="col-lg-5 col-md-5 col-sm-12" v-if="0>1">
            <div v-if="showImage">
              <va-box title="Printer Image" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerInfo" :imagesList="images" @imageChanged="imageChanged">
                <div slot="content">
                  <img style="width: 100%; min-height: 300px; max-height: 500px;" :src="printer.imgUrl" ref="printerImage" />
                  <loading :active.sync="loadingImage" :is-full-page="isFullpage"></loading>
                </div>
                <div slot="footer">
                  <i class="fa fa-spinner fa-spin"></i>
                  <span>Saving image...</span>
                </div>
              </va-box>
            </div>
            <div>
              <va-box title="Printer Status" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerStatus">
                <div slot="content">
                  <div class="col-sm-12" v-for="item in printerStatus" style="padding-bottom: 10px;">
                    <span class="description-text">{{item.title}}</span>
                    <div class="description-block" style="background-color: #eee; padding: 5px; margin: 0px; height: 30px;">
                      <b class="text-right pull-right">{{item.value}}</b>
                    </div>
                  </div>
                </div>
              </va-box>
            </div>
            <va-box title="Printer Toners" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerToners">
              <div slot="content">
                <div class="col-sm-3" v-for="item in printerToners">
                  <div class="description-block" style="padding: 5px; height: 50px;">
                    <span class="col-sm-5 description-text text-left">{{item.title}}</span>
                    <br />
                    <span>
                      <div class="progress-group" style="width: 80px;">
                        <div class="progress sm" style="background-color: #ccc; height: 20px;">
                          <div v-if="item.value >= 0" :class="['progress-bar', 'progress' + item.title]" :style="{ width: item.value + '%' }">{{item.value}}%</div>
                          <div v-else>N/A</div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </va-box>
            <va-box title="Printer Properties" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerProps">
              <div slot="content">
                <div class="col-sm-4" v-for="printerProp in printerProps" @click="printerProp.Value = !printerProp.Value">
                  <div class="tree-content tree--small" style="float: left!important;">
                    <i :class="['tree-checkbox', printerProp.Value?'checked':'']"></i>
                    <span tabindex="-1" class="tree-anchor">
                      <span class="tree-text" style="white-space: nowrap;">{{printerProp.Key}}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div slot="footer" v-if="$root.isAdmin || $root.isDealer">
                <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancelType"></va-button>
                <va-button :isBlock="false" theme="success" name="Save" align="right" @click.native="saveType" style="margin-right: 10px;"></va-button>
              </div>
            </va-box>
          </div>
        </div>
      </div>
    </div>
    <!--<loading :active.sync="loadingPrinter" :is-full-page="isFullpage"></loading>-->
  </div>
</template>
<script>
  import Loading from 'vue-loading-overlay'
  import VABox from '../components/VABox'
  import VAButton from '../components/VAButton'
  import VAAlert from '../components/VAAlert.vue'
  import VueTable from '../components/Table/DataTable.vue'
  import { db } from '../firebase'
  export default {
    name: 'Dealer',
    components: {
      'loading': Loading,
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton,
      VueTable
    },
    data () {
      return {
        dealerInfo: [],
        dealerProgress: [],
        title: ''
      }
    },
    firebase: function () {
      let dealerPath = 'Dealers/' + this.$route.params.dealerKey
      let dealerRef = db.ref(dealerPath)
      return {
        dealer: {
          source: dealerRef,
          asObject: true,
          cancelCallback: function () { },
          readyCallback: function () {
            this.initDealerInfo()
          }
        }
      }
    },
    created () {
      this.$root.title = 'Dealer'
      this.loadingPrinter = true
    },
    mounted () {
      console.log('Dealer mounted')
    },
    methods: {
      initDealerInfo () {
        let vm = this
        this.title = 'Dealer ' + '[' + this.dealer['.key'] + ']'
        this.title = 'Dealer ' + '[' + this.dealer.FullName + ']'
        console.log(this.title)
        console.log(this.dealer)
        this.dealerInfo = []
        this.dealerInfo.push({ title: 'Full Name', value: this.dealer.FullName })
        if (this.dealer.CreateDate) {
          this.dealerInfo.push({ title: 'Create Date', value: this.dealer.CreateDate })
        } else {
          this.dealerInfo.push({ title: 'Create Date', value: '2019-01-01 12:00:00' })
        }
        this.dealerInfo.push({ title: 'Dealer Key', value: this.dealer['.key'] })
        let totalCustomers = 0
        let totalSites = 0
        if (this.dealer.Customers) {
          let keys = Object.keys(this.dealer.Customers)
          if (keys && keys.length > 0) {
            totalCustomers = keys.length
            for (let c = 0; c < keys.length; c++) {
              let cKey = keys[c]
              let customer = this.dealer.Customers[cKey]
              if (customer && customer.Sites) {
                let sKeys = Object.keys(customer.Sites)
                if (sKeys && sKeys.length > 0) {
                  totalSites += sKeys.length
                }
              }
            }
          }
        }
        db.ref('Users/' + this.dealer['.key']).orderByKey().once('value', (snapUser) => {
          const dataUser = snapUser.val()
          if (dataUser) {
            console.log(dataUser)
            this.dealerInfo.push({ title: 'Email', value: dataUser.Email })
            this.dealerInfo.push({ title: 'Phone', value: dataUser.Phone })
            this.dealerInfo.push({ title: 'Company Name', value: dataUser.CompanyName })
            this.dealerInfo.push({ title: 'Country', value: dataUser.Country })
          }
        })
        this.dealerInfo.push({ title: 'Total Customers', value: totalCustomers + ' Customers' })
        this.dealerInfo.push({ title: 'Total Sites', value: totalSites + ' Sites' })
        console.log('Init Dealer Progress from Alerts .... ')
        this.dealerProgress = []
        db.ref('Alerts').orderByChild('DealerKey').equalTo(this.dealer['.key']).limitToFirst(1000).once('value', (snapAlerts) => {
          const data = snapAlerts.val()
          if (data) {
            console.log(data)
            let alerts = []
            const keys = Object.keys(data)
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let item = data[key]
              if (item && item.Type === 'System') {
                item['.key'] = key
                alerts.push(item)
              }
            }
            alerts = alerts.slice().sort(function (a, b) {
              return a.LoggedInt > b.LoggedInt ? -1 : 1
            })

            for (let a = 0; a < alerts.length; a++) {
              // Logged
              // Title
              // Message
              this.dealerProgress.push({ title: alerts[a].Logged, value: alerts[a].Message })
            }
          }
        })
        vm.loadingPrinter = false
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Dealer.vue?5708aae9